var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.gameState.inExplorationModal
    ? _c(
        "div",
        { staticClass: "exploration-modal", on: { click: _vm.closeModal } },
        [
          _c(
            "div",
            {
              staticClass: "exploration-card",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("div", { staticClass: "exploration-header" }, [
                _c("h3", [_vm._v(_vm._s(_vm.currentScene.name))]),
                _vm._v(" "),
                _vm.isFirstExploration
                  ? _c("p", [_vm._v(_vm._s(_vm.currentScene.description))])
                  : _c("p", { staticClass: "exploration-continue" }, [
                      _vm._v("继续探索中..."),
                    ]),
                _vm._v(" "),
                _vm.explorationState && _vm.newClues.length > 0
                  ? _c("div", { staticClass: "clues-section" }, [
                      _c("h4", [_vm._v("新线索：")]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(_vm.newClues, function (clue) {
                          return _c("li", { key: clue }, [_vm._v(_vm._s(clue))])
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "exploration-content" }, [
                _vm.triggeredEvent
                  ? _c("div", { staticClass: "random-event-section" }, [
                      _c("h4", [_vm._v("🎯 特殊事件触发")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "event-card" }, [
                        _c("h5", [_vm._v(_vm._s(_vm.triggeredEvent.name))]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(_vm._s(_vm.triggeredEvent.description)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "event-narrative" }, [
                          _vm._v(_vm._s(_vm.triggeredEvent.narrative)),
                        ]),
                        _vm._v(" "),
                        _vm.eventResults.length > 0
                          ? _c(
                              "div",
                              { staticClass: "event-results" },
                              _vm._l(_vm.eventResults, function (result) {
                                return _c(
                                  "div",
                                  { key: result, staticClass: "event-result" },
                                  [_vm._v(_vm._s(result))]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "continue-btn",
                          on: { click: _vm.continueExploration },
                        },
                        [_vm._v("继续探索")]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.explorationResults.length > 0
                  ? _c("div", { staticClass: "results-section" }, [
                      _c("h4", [_vm._v("探索结果：")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "result-messages" },
                        _vm._l(
                          _vm.explorationResults,
                          function (result, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                class: [
                                  "result-message",
                                  {
                                    "item-gained":
                                      _vm.isItemGainMessage(result),
                                  },
                                ],
                              },
                              [
                                _vm.isItemGainMessage(result)
                                  ? _c("span", { staticClass: "item-icon" }, [
                                      _vm._v("🎒"),
                                    ])
                                  : _vm._e(),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.getResultText(result)) +
                                    "\n          "
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "continue-btn",
                          on: { click: _vm.continueExploration },
                        },
                        [_vm._v("继续探索")]
                      ),
                    ])
                  : _c("div", { staticClass: "actions-section" }, [
                      _c("h4", [_vm._v("你可以：")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "action-buttons" },
                        _vm._l(_vm.availableActions, function (action, index) {
                          return _c(
                            "button",
                            {
                              key: `action-${index}`,
                              staticClass: "action-button",
                              attrs: { disabled: _vm.isProcessing },
                              on: {
                                click: function ($event) {
                                  return _vm.handleActionClick(
                                    action,
                                    index + 1
                                  )
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "action-number" }, [
                                _vm._v(_vm._s(index + 1) + "."),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "action-text" }, [
                                _vm._v(_vm._s(action)),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "end-btn",
                          on: { click: _vm.endExploration },
                        },
                        [_vm._v("结束探索")]
                      ),
                    ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "exploration-footer" }, [
                _c("div", { staticClass: "exploration-stats" }, [
                  _c("span", [
                    _vm._v(
                      "探索心情：" +
                        _vm._s(
                          _vm.explorationState
                            ? _vm.explorationState.mood
                            : "未知"
                        )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "发现数量：" +
                        _vm._s(
                          _vm.explorationState
                            ? _vm.explorationState.discovered.length
                            : 0
                        )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "close-btn", on: { click: _vm.closeModal } },
                  [_vm._v("关闭")]
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }